import styled from 'styled-components';
export var FinectLogoContainer = styled.div.withConfig({
  displayName: "FinectLogoContainer",
  componentId: "sc-1pcqi1c-0"
})(["width:fit-content;margin:0 auto;padding:30px 0 0;"]);